import services from "@/services";

const state = {
  data: [],
  detail: {},
  loading: false,
  error: null,
};

const getters = {
  parsedContentText: (state) => {
    let parsed = state.data?.map((x) => {
      x.actions = {
        id: x.id,
        url: `content-text/${x.id}`,
        edit: "enable",
        delete: "enable",
      };
      x.param = x.content_data.map((item) => item.param);
      x.value = x.content_data.map((item) => item.value);
      return x;
    });
    return parsed;
  },
};

const mutations = {
  setContentData: (state, data) => {
    state.data = data;
  },
  setContentDetail: (state, detail) => {
    state.detail = detail;
  },
  setLoading: (state, bool) => {
    state.loading = bool;
  },
};

const actions = {
  getAll({ commit, dispatch }, param) {
    services.setHeader();
    dispatch("setLoadingTable", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .get("content-text", param)
        .then((response) => {
          commit("setContentData", response.data.data.items);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingTable", false, { root: true });
        });
    });
  },
  getOneContent({ commit, dispatch }, id) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .get("content-text/" + id)
        .then((response) => {
          commit("setContentDetail", response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
  delete({ commit, dispatch }, id) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .delete(`content-text/${id}`, { id })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
  createContent({ commit, dispatch }, body) {
    /**
		 		"content_title": "testing",
    		"content_data": [
					{
							"param": "testing sub",
							"value": "test next value sub"
					}
				]
		 */
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .post("content-text", body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
  updateContent({ commit, dispatch }, payload) {
    services.setHeader();
    dispatch("setLoadingGlobal", true, { root: true });
    return new Promise((resolve, reject) => {
      services
        .put("content-text/" + payload.id, payload.body)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          dispatch("setLoadingGlobal", false, { root: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
